import React from 'react';

const PolicyPDFViewer = ({pdfUrl}) => {
  return (
    <div style={{width: '100%', height: '100vh'}}>
      <iframe
        src={pdfUrl}
        style={{
          width: '100%',
          height: '100%',
          border: 'none',
        }}
        title="PDF Viewer"
      >
        <p>
          Your browser does not support PDFs.{' '}
          <a href={pdfUrl} target="_blank" rel="noopener noreferrer">
            Download the PDF
          </a>
        </p>
      </iframe>
    </div>
  );
};

export default PolicyPDFViewer;
